import { createTheme } from '@mui/material/styles';

// Navy Blue Dark Theme
const theme = createTheme({
  direction: 'rtl',
  palette: {
    mode: 'dark',
    primary: {
      main: '#5b7cfa',
      light: '#6b8aff',
      dark: '#4a6ce8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#8baaff',
      light: '#9bbaff',
      dark: '#7b9aff',
      contrastText: '#ffffff',
    },
    background: {
      default: '#1a1f3a',
      paper: '#252b4a',
    },
    text: {
      primary: '#ffffff',
      secondary: '#c5d0f0',
      disabled: '#9ba5c4',
    },
    divider: 'rgba(91, 124, 250, 0.3)',
    success: {
      main: '#26de81',
      contrastText: '#ffffff',
    },
    error: {
      main: '#fc5c65',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#fed330',
      contrastText: '#ffffff',
    },
    info: {
      main: '#5b7cfa',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Vazir, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.75rem',
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: 'linear-gradient(135deg, #1a1f3a 0%, #2d3561 50%, #1a1f3a 100%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'linear-gradient(135deg, #252b4a 0%, #2d3561 100%)',
          background: 'linear-gradient(135deg, #252b4a 0%, #2d3561 100%)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, #252b4a 0%, #2d3561 100%)',
          boxShadow: '0 4px 20px rgba(26, 31, 58, 0.4)',
          border: '1px solid rgba(91, 124, 250, 0.3)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          padding: '10px 20px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            background: 'linear-gradient(135deg, #252b4a 0%, #2d3561 100%)',
            '& fieldset': {
              borderColor: 'rgba(91, 124, 250, 0.3)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(91, 124, 250, 0.5)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#5b7cfa',
            },
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: 'rgba(91, 124, 250, 0.1)',
            fontWeight: 600,
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(91, 124, 250, 0.15)',
          },
        },
      },
    },
  },
});

export default theme;

